module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAAAxCAMAAAB+kg5dAAAAS1BMVEXKysrKysrKysoAAADKysrKysrKysrKysr/AA4AAAD/xgDKyspWVlb/yRr+xgTsMz22trbPtrjPyrbZk5bZyZOTk5PiKTPIlZjYxJSPiPiVAAAACHRSTlOZTB4A8IHbKXuwYjUAAABkSURBVEjH7czJEYAgEATAheVQ8cALzT9SiyIDan5OB9Ci1guQjyoaEpRTsSnPQDmZWo5AN0uWLFn2lHspG0gpTysHoJMlS5Yse8pjAXpbOQFdLFmy/EO5AtVSXcKKoiYgQ+f1A7nXkp7y5nyWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/dialog-flag-germany.png
// module id = GrMT
// module chunks = 1